Drupal.behaviors.sw_pap = {
  attach: function( context, settings ) {

    if ( typeof PostAffTracker === 'undefined' ) {
      SwPAPOnLoad();
    }

  }
};

function SwPAPOnLoad () {
  $('body').once('sw-pap').each(function() {

    $('.js-pap-affiliate-id').each(function() {
      const $i = $(this);
      let aff_id = null;
      if ( typeof PostAffTracker !== 'undefined' ) {
        aff_id = PostAffTracker.getAffInfo().getAffiliateId();
      }
      if ( !aff_id ) {
        aff_id = Cookies.get('sw-pap-aff-id');
      }
      if ( aff_id && aff_id !== $i.val()) {
        $i.val(aff_id);
        if ( $i.hasClass('js-pap-form-submit-on-change')) {
          $i.closest('form').find('input[type="submit"][name="op_plan_apply"]').trigger('mousedown');
        }
      }
    });

    $('.js-pap-visitor-id').each(function() {
      const $i = $(this);
      if ( typeof PostAffTracker !== 'undefined' ) {
        $i.val(PostAffTracker.getVisitorId());
      }
    });

  });
}

$(document).on('keyup', function(e){
  if ( e.key === 'T' && e.ctrlKey && e.shiftKey ) {
    $('.js-pap-affiliate-id, .js-pap-visitor-id').once('sw_pap').each(function() {
      const $i = $(this);
      $i.attr('type', 'text');
      $('<label>'+$i.attr('name')+'</label>').insertBefore($i);
    });
  }
});
